module.exports = __webpack_public_path__ + "static/media/previous-meeting.fbb436dd.svg";